import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { PrimeNgModule } from "@primeng";
import { GridModule } from "@features/grid";
import { FilterModule } from "@features/filter";
import { BbwtSharedModule } from "@bbwt/bbwt-shared.module";
import { PdfExportingHub } from "@main/pdf-exporting/api/pdf-exporting.hub";
import { PdfExportingService } from "@main/pdf-exporting/api/pdf-exporting.service";
import {
    PdfExportingComponent
} from "@main/pdf-exporting/components/pdf-export-handling/pdf-exporting.component";
import {
    PdfExportSummaryComponent
} from "@main/pdf-exporting/components/pdf-export-handling/pdf-export-summary.component";
import {
    PdfExportDataPageComponent
} from "@main/pdf-exporting/components/pdf-export-data/pdf-export-data-page.component";
import {
    PdfExportDataTableComponent
} from "@main/pdf-exporting/components/pdf-export-data/pdf-export-data-table.component";

@NgModule({
    declarations: [
        PdfExportingComponent,
        PdfExportSummaryComponent,
        PdfExportDataPageComponent,
        PdfExportDataTableComponent
    ],
    imports: [
        GridModule,
        FilterModule,
        PrimeNgModule,
        BbwtSharedModule
    ],
    exports: [
        PdfExportingComponent,
        PdfExportDataPageComponent,
        PdfExportDataTableComponent
    ],
    providers: [
        PdfExportingHub,
        PdfExportingService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PdfExportingModule {
}